import React from "react";
import { Link } from "react-router-dom";

import Constants from "app_constants";
import Theme from "./theme";

const LoginView = (props) => {
  const { login, setFormData, error } = props;

  return (
    <Theme>
      {Constants.metaTag}

      <div class="box">
        <div className="panel">
          <div className="field">
            <label className="label">E-mail</label>
            <div className="control">
              <input
                onChange={(e) => {
                  setFormData("email", e.target.value);
                }}
                className="input is-info"
                type="text"
              />
            </div>
          </div>

          <div className="field">
            <label className="label">Password</label>
            <div className="control">
              <input
                onChange={(e) => {
                  setFormData("password", e.target.value);
                }}
                className="input is-info"
                type="password"
              />
            </div>
          </div>
          {error && <p className="error">{error}</p>}
          <button
            onClick={login}
            className="button is-info is-fullwidth submit"
          >
            Login
          </button>

          <div className="bottomSection">
            <Link to="/register">
              <p className="link">Sign Up</p>
            </Link>

            <Link to="/reset-password">
              <p className="link">Reset Password</p>
            </Link>
          </div>
        </div>
      </div>
    </Theme>
  );
};

export default LoginView;
